import React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from "react-i18next";
import { app, dialog, UrlDialogInfo } from "@microsoft/teams-js";
import { getBaseUrl } from '../../configVariables';
import { deleteDraftNotification, duplicateDraftNotification, sendPreview } from '../../apis/messageListApi';
import { selectMessage, getMessagesList, getScheduledMessagesList, getDraftMessagesList } from '../../actions';
import { TFunction } from "i18next";
import { Menu, MenuTrigger, MenuButton, MenuPopover, MenuList, MenuItem, MenuDivider } from '@fluentui/react-components';
import { MoreHorizontal24Regular, Send24Regular, Open24Regular, Edit24Regular, SaveCopy24Regular, Delete24Regular } from '@fluentui/react-icons';


export interface OverflowProps extends WithTranslation {
    message: any;
    styles?: object;
    title?: string;
    selectMessage?: any;
    getMessagesList?: any;
    getDraftMessagesList?: any;
    getScheduledMessagesList?: any;
    resetPageCallback?: any;
}

export interface OverflowState {
    teamsTeamId?: string;
    teamsChannelId?: string;
}

export interface ITaskInfo {
    title?: string;
    height?: number;
    width?: number;
    url?: string;
    card?: string;
    fallbackUrl?: string;
    completionBotId?: string;
}

class Overflow extends React.Component<OverflowProps, OverflowState> {
    readonly localize: TFunction;
    constructor(props: OverflowProps) {
        super(props);
        this.localize = this.props.t;
        this.state = {
            teamsChannelId: '',
            teamsTeamId: ''
        };
    }

    public componentDidMount() {
        app.initialize().then(() => {
            app.getContext().then((context: app.Context) => {
                this.setState({
                    teamsTeamId: context.team?.internalId,
                    teamsChannelId: context.channel?.id,
                });
            });
        });
    }

    public render(): JSX.Element {
        return <Menu>
            <MenuTrigger disableButtonEnhancement>
                <MenuButton onClick={e => e.stopPropagation()} icon={< MoreHorizontal24Regular />} appearance='transparent' />
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    <MenuItem key='send' icon={<Send24Regular/>} onClick={this.onSendClick}>{this.localize("Send")}</MenuItem>
                    <MenuItem key='preview' icon={<Open24Regular/>} onClick={this.onPreviewClick}>{this.localize("Preview")}</MenuItem>
                    <MenuItem key='edit' icon={<Edit24Regular/>} onClick={this.onEditClick}>{this.localize("Edit")}</MenuItem>
                    <MenuItem key='duplicate' icon={<SaveCopy24Regular/>} onClick={this.onDuplicateClick}>{this.localize("Duplicate")}</MenuItem>
                    <MenuDivider />
                    <MenuItem key='delete' icon={<Delete24Regular/>} onClick={this.onDeleteClick}>{this.localize("Delete")}</MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    }

    private onSendClick = (event: any) => {
        event.stopPropagation();
        let url = getBaseUrl() + "/sendconfirmation/" + this.props.message.id + "?locale={locale}";
        this.onOpenTaskModule(null, url, this.localize("SendConfirmation"));
    }

    private onPreviewClick = (event: any) => {
        event.stopPropagation();
        let payload = {
            draftNotificationId: this.props.message.id,
            teamsTeamId: this.state.teamsTeamId,
            teamsChannelId: this.state.teamsChannelId,
        }
        sendPreview(payload).then((response) => {
            return response.status;
        }).catch((error) => {
            return error;
        });
    }

    private onEditClick = (event: any) => {
        event.stopPropagation();
        let url = getBaseUrl() + `/newmessage/draft/${this.props.message.id}?locale={locale}`;
        this.onOpenTaskModule(null, url, this.localize("EditMessage"));
    }

    private onDuplicateClick = (event: any) => {
        event.stopPropagation();
        this.duplicateDraftMessage(this.props.message.id).then(() => {
            this.props.getDraftMessagesList();
        });
    }

    private onDeleteClick = (event: any) => {
        event.stopPropagation();
        this.deleteDraftMessage(this.props.message.id).then(() => {
            this.props.getDraftMessagesList();
        });
    }

    private onOpenTaskModule = (event: any, url: string, title: string) => {
        const taskInfo: UrlDialogInfo = {
            url: url,
            title: title,
            size: {
                height: 660,
                width: 1000
            },
            fallbackUrl: url,
        };

        let submitHandler = (result: dialog.ISdkResponse) => {
            this.props.getDraftMessagesList().then(() => {
                this.props.resetPageCallback();
                this.props.getMessagesList().then(() => {
                    this.props.getScheduledMessagesList();
                });

            });
        };

        dialog.url.open(taskInfo, submitHandler);
    }

    private duplicateDraftMessage = async (id: number) => {
        try {
            await duplicateDraftNotification(id);
        } catch (error) {
            return error;
        }
    }

    private deleteDraftMessage = async (id: number) => {
        try {
            await deleteDraftNotification(id);
        } catch (error) {
            return error;
        }
    }
}

const mapStateToProps = (state: any) => {
    return { messages: state.draftMessagesList, selectedMessage: state.selectedMessage };
}

const overflowWithTranslation = withTranslation()(Overflow);
export default connect(mapStateToProps, { selectMessage, getScheduledMessagesList, getDraftMessagesList, getMessagesList })(overflowWithTranslation);
